'use client';
import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const faqs = [
  { id: 'faq-01', q: 'Is Nerdlora free to use?', a: 'Nerdlora offers a free tier with access to 20 curated courses and SHS subject previews. For full access including live classes, certificates, and all 380+ courses, the Pro plan starts at GHS 89/month.' },
  { id: 'faq-02', q: 'Are the certificates recognized by employers?', a: 'Nerdlora digital certificates are industry-recognized and blockchain-verifiable. Many of our graduates have used them to land roles at companies including Hubtel, mPharma, and Vodafone Ghana.' },
  { id: 'faq-03', q: 'How does the SHS section work?', a: 'The SHS Learning Hub is a dedicated section for Senior High School students in Ghana. It covers all core WAEC subjects with structured lessons, past question practice, and live revision sessions from experienced SHS teachers.' },
  { id: 'faq-04', q: 'Can I learn on my phone?', a: 'Yes. Nerdlora is fully mobile-responsive and we have a progressive web app (PWA) for offline learning. Download lessons when connected and watch them without internet.' },
  { id: 'faq-05', q: 'How do I become an instructor on Nerdlora?', a: 'Apply through the Instructor portal. Our team reviews your credentials, teaching samples, and course outline within 5 business days. Approved instructors earn 70% revenue share on every enrollment.' },
  { id: 'faq-06', q: 'What payment methods are accepted?', a: 'We accept MTN Mobile Money, AirtelTigo Money, Vodafone Cash, Visa/Mastercard, and bank transfer. All transactions are secured and processed in GHS.' },
];

export default function FAQSection() {
  const [open, setOpen] = useState<string | null>('faq-01');

  return (
    <section className="py-16 bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-10">
          <p className="text-sm font-semibold text-primary mb-2 uppercase tracking-widest">FAQ</p>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-foreground">
            Common <span className="text-gradient">questions</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs?.map((faq) => (
            <div key={faq?.id} className="bg-card rounded-2xl border border-border shadow-card overflow-hidden">
              <button
                onClick={() => setOpen(open === faq?.id ? null : faq?.id)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-muted/50 transition-colors"
              >
                <span className="font-semibold text-foreground text-sm">{faq?.q}</span>
                <Icon
                  name={open === faq?.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                  size={18}
                  className="text-muted-foreground flex-shrink-0 ml-4 transition-transform"
                />
              </button>
              {open === faq?.id && (
                <div className="px-6 pb-5 animate-fade-in">
                  <p className="text-sm text-muted-foreground leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}